import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
// import components
import Header from './components/Header';
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import Home from "./Pages/Home";
import Aboutpage from "./Pages/Aboutpage";
import Privacypolicy from "./Pages/Privacypolicy";
import JobOpeningSection from "./Pages/Career";
import Contactpage from "./Pages/Contactpage";
import TaxService from "./Pages/TaxService";
import ScrollToTop from "./components/ScrollToTop";
import FloatingCTA from "./components/FloatingCTA";
import Navbar from "./components/Navbar";

const App = () => {
  return (
    <>
      
    <Navbar />
      <Router>
        <ScrollToTop />
        <FloatingCTA />
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/about" element={<Aboutpage/>} />
          <Route path="/careers" element={<JobOpeningSection/>} />
          <Route path="/contact-us" element={<Contactpage/>} />
          <Route path="/privacy-policy" element={<Privacypolicy/>} />
          <Route path="/contact-us" element={<Contactpage/>} />
          <Route path="/tax-service" element={<TaxService />} />
        </Routes>
      </Router>
      <Footer />
      <BackToTop />
    </>
  );
};

export default App;
